import { useState, useEffect } from 'react';
import type { LoadingDialogProps } from '../types/ui';
import './LoadingDialog.css';

const LoadingDialog = ({ messages, title, isOpen = true }: LoadingDialogProps) => {
    const [currentMessageIndex, setCurrentMessageIndex] = useState<number>(0);

    useEffect(() => {
        if (isOpen) {
            setCurrentMessageIndex(0);
        }
    }, [isOpen, messages]);

    useEffect(() => {
        if (!isOpen || !messages.length || currentMessageIndex >= messages.length - 1) {
            return;
        }

        const timer = setInterval(() => {
            setCurrentMessageIndex((prev) => {
                return prev < messages.length - 1 ? prev + 1 : prev;
            });
        }, 2000);

        return () => clearInterval(timer);
    }, [currentMessageIndex, messages.length, isOpen]);

    if (!isOpen) return null;

    return (
        <div className="sky-loading-overlay">
            <div className="sky-loading-dialog">
                {title && <div className="sky-loading-title">{title}</div>}
                <div className="sky-loading-body">
                    <div className="sky-spinner" />
                    <div
                        className={`sky-loading-message ${
                            currentMessageIndex === messages.length - 1 ? 'static' : ''
                        }`}
                    >
                        {messages[currentMessageIndex] || ''}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default LoadingDialog;
